export default __webpack_public_path__ + "static/media/logo.ca99fd4a.png";